<div class="flex flex-1 flex-row flex-wrap items-center gap-xs">
  <p class="text-base">{{ title }}</p>
  <div class="relative inline h-6 min-w-[8rem] shrink grow basis-1/2">
    <ng-content select="[content=logo]"></ng-content>
  </div>
</div>
